import {RemixBrowser} from '@remix-run/react';
import ShopifyFormat from '@shopify/i18next-shopify';
import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import {startTransition} from 'react';
import {hydrateRoot} from 'react-dom/client';
import {I18nextProvider, initReactI18next} from 'react-i18next';
import {getInitialNamespaces} from 'remix-i18next/client';

import i18nextOptions from './i18n/i18nextOptions';

function hydrate() {
  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <RemixBrowser />
      </I18nextProvider>,
    );
  });
}

async function initI18n() {
  const lng = document.documentElement.lang || i18nextOptions.fallbackLng;

  await i18next
    .use(initReactI18next)
    .use(ShopifyFormat.default ?? ShopifyFormat)
    .use(
      resourcesToBackend((language: string, namespace: string) => {
        // Locale JSON is served from stable, non-hashed URLs, but remix-serve
        // tags the whole build/client dir `immutable, max-age=1y`. Browsers
        // that cached a file before a translation change keep the stale copy
        // (immutable suppresses revalidation), rendering raw keys. Keying the
        // request on the per-build manifest version changes the cache URL each
        // deploy, so updated strings can't be stranded behind a poisoned entry.
        const version =
          (window as unknown as {__remixManifest?: {version?: string}})
            .__remixManifest?.version ?? '';
        const query = version ? `?v=${encodeURIComponent(version)}` : '';
        return fetch(`/locales/${language}/${namespace}.json${query}`).then(
          (res) => res.json(),
        );
      }),
    )
    .init({
      ...i18nextOptions,
      lng,
      ns: getInitialNamespaces(),
    });
}

initI18n().then(hydrate);
